const firebase = require("firebase");
require("firebase/firestore");

firebase.initializeApp({
  apiKey: "AIzaSyDwKbSmFpKa3FzSGyn8JLhH2yuPSU0dqtk",
  authDomain: "vb.herohtar.com",
  databaseURL: "https://volleyball-scheduler.firebaseio.com",
  projectId: "volleyball-scheduler",
  storageBucket: "volleyball-scheduler.appspot.com",
  messagingSenderId: "652622990691"
});

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.jsx